import React from 'react';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Label } from '../ui/label';

export const PublicationAudienceMode = ({ value, onChange, prefix = 'pub', disabled = false }) => (
  <RadioGroup value={value} onValueChange={onChange} disabled={disabled} className="gap-3 border-b border-[#E8E6E1] pb-4" aria-label="Audience de la publication" data-testid={`${prefix}-audience-mode`}>
    <div className="flex items-center gap-2">
      <RadioGroupItem value="all_portal_members" id={`${prefix}-all-portal-members`} data-testid={`${prefix}-audience-all`} />
      <Label htmlFor={`${prefix}-all-portal-members`} className="cursor-pointer text-sm">Tous les membres du portail</Label>
    </div>
    <div className="flex items-center gap-2">
      <RadioGroupItem value="individual" id={`${prefix}-individual-recipients`} data-testid={`${prefix}-audience-individual`} />
      <Label htmlFor={`${prefix}-individual-recipients`} className="cursor-pointer text-sm">Destinataires sélectionnés</Label>
    </div>
    <div className="flex items-center gap-2">
      <RadioGroupItem value="targeted" id={`${prefix}-targeted-audience`} data-testid={`${prefix}-audience-targeted`} />
      <Label htmlFor={`${prefix}-targeted-audience`} className="cursor-pointer text-sm">Audience ciblée / espace</Label>
    </div>
  </RadioGroup>
);